/**
 * For a TikTok URL, the post (with optional handle from the URL), or null when the URL isn't a
 * resolvable post (a profile, a truncated path, an unknown shape).
 */
export function matchTiktokPost(url: URL): { handle: string | undefined } | null {
	const host = url.hostname.toLowerCase();
	// Full canonical post: /@handle/video/123 or /@handle/photo/123 — handle is extractable.
	const canonical = /^\/@([\w.-]+)\/(?:video|photo)\/\d+/.exec(url.pathname);
	if (canonical) return { handle: `@${canonical[1]}` };
	// Short share links carry no handle in the URL: vm./vt./m.tiktok.com/<id> or /t/<id>.
	const isShortHost = host !== 'tiktok.com' && host !== 'www.tiktok.com';
	if (isShortHost && url.pathname.length > 1) return { handle: undefined };
	if (/^\/t\/[\w-]+/.test(url.pathname)) return { handle: undefined };
	return null;
}
